import { baseRoute } from '../../../constants/routes';

export const CLEAR_STATISTIC_PREVIEW = baseRoute + '/delete-preview';

export const SET_PREVIEW_QUIZ = 'SET_PREVIEW_QUIZ';
export const SET_PREVIEW_QUIZ_SUCCESS = 'SET_PREVIEW_QUIZ_SUCCESS';

export const SET_PREVIEW_QUESTIONLIST = 'SET_PREVIEW_QUESTIONLIST';
export const SET_PREVIEW_QUESTIONLIST_SUCCESS = 'SET_PREVIEW_QUESTIONLIST_SUCCESS';

export const SET_PREVIEW_DISPLAY = 'SET_PREVIEW_DISPLAY';
export const SET_PREVIEW_DISPLAY_SUCCESS = 'SET_PREVIEW_DISPLAY_SUCCESS';

export const SET_PREVIEW_QUIZ_SETTINGS = 'SET_PREVIEW_QUIZ_SETTINGS';
export const SET_PREVIEW_QUIZ_SETTINGS_SUCCESS = 'SET_PREVIEW_QUIZ_SETTINGS_SUCCESS';